import { storagePath } from '@helpers/variables'
import _ from 'lodash'

export const groupBy = (items, key, nestedKey = null) => {
  if (nestedKey === null) {
    // No nestedKey provided, returns in form of { key: [{}, {}] }
    return items.reduce((acc, item) => {
      return { ...acc, [item[key]]: [...(acc[item[key]] || []), item] }
    }, {})
  } else {
    // nestedKey present, returns in form of { nestedKey: {name: 'nameKeyNextToNestedKey', items: [{}, {}] }

    return items.reduce((acc, item) => {
      if (item[key][nestedKey] in acc) {
        // Already exist, append to items
        acc[item[key][nestedKey]].items.push(item)
        return acc
      } else {
        // First setup node and populate first item
        acc[item[key][nestedKey]] = {
          name: item[key]['name'],
          items: [item],
        }
        return acc
      }
    }, {})

    // return items.reduce((acc, item) => {
    //     return {
    //         ...acc,
    //         [item[key][nestedKey]]: [
    //             ...(acc[item[key][nestedKey]] || []),
    //             item,
    //         ],
    //     }
    // }, {})
  }
}

export const shuffleArray = (original) => {
  let array = _.cloneDeep(original)
  var currentIndex = array.length,
    temporaryValue,
    randomIndex

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

export const moveItemInArray = (arr, from, to) => {
  // Make sure a valid array is provided
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    throw new Error('Please provide a valid array')
  }

  // Make copy
  let arrCopy = [...arr]

  // Delete the item from it's current position
  var item = arrCopy.splice(from, 1)

  // Make sure there's an item to move
  if (!item.length) {
    throw new Error('There is no item in the array at index ' + from)
  }

  // Move the item to its new position
  arrCopy.splice(to, 0, item[0])

  return arrCopy
}

/**
 * Adds item if it doesn't exist and removes it if it does exist
 */
export const toggleArrayItem = (array, item) => {
  const arrayCopy = [...array]
  const index = arrayCopy.indexOf(item)

  index === -1 ? arrayCopy.push(item) : arrayCopy.splice(index, item)

  return arrayCopy
}

export const removeDuplicates = (array) => {
  return [...new Set(array)]
}

/**
 * Adds item if it doesn't exist and removes it if it does exist
 */
export const readFileAsDataURL = async (file) => {
  let result_base64 = await new Promise((resolve) => {
    let fileReader = new FileReader()
    fileReader.onload = (e) => resolve(fileReader.result)
    fileReader.readAsDataURL(file)
  })

  return result_base64
}

const isValidSingleImageFilename = (filename) => {
  const imagePattern = /^[^\/\\]+(\.(jpg|jpeg|png|gif|bmp|webp|svg))$/i
  return imagePattern.test(filename)
}

export const getImageSrc = (image) => {
  if (image?.filename) {
    // console.log('🚀 ~ file: utilities.js ~ line 110 ~ filename')

    return image.filename
  }
  if (image?.previewUrl && image?.previewUrl instanceof File) {
    // console.log('🚀 ~ file: utilities.js ~ line 110 ~ url', image)

    return URL.createObjectURL(image?.previewUrl)
  }

  if (isValidSingleImageFilename(image)) {
    return `${storagePath}/${image}`
  }

  return null
}

/**
 * Get the value of a cookie
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
export const getCookie = (name) => {
  let value = `; ${document.cookie}`
  let parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}
